const cfr = {
    "Afghanistan": "Afghanistan",
    "South Africa": "Afrique du Sud",
    "Albania": "Albanie",
    "Algeria": "Algérie",
    "Germany": "Allemagne",
    "Andorra": "Andorre",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua-et-Barbuda",
    "Saudi Arabia": "Arabie saoudite",
    "Argentina": "Argentine",
    "Armenia": "Arménie",
    "Australia": "Australie",
    "Austria": "Autriche",
    "Azerbaijan": "Azerbaïdjan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahreïn",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbade",
    "Belgium": "Belgique",
    "Belize": "Belize",
    "Benin": "Bénin",
    "Bhutan": "Bhoutan",
    "Belarus": "Biélorussie",
    "Myanmar": "Birmanie",
    "Bolivia": "Bolivie",
    "Bosnia and Herzegovina": "Bosnie-Herzégovine",
    "Botswana": "Botswana",
    "Brazil": "Brésil",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgarie",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Cabo Verde",
    "Cambodia": "Cambodge",
    "Cameroon": "Cameroun",
    "Canada": "Canada",
    "Central African Republic": "République centrafricaine",
    "Chad": "Tchad",
    "Chile": "Chili",
    "China": "Chine",
    "Cyprus": "Chypre",
    "Colombia": "Colombie",
    "Comoros": "Comores",
    "Republic of the Congo": "République du Congo",
    "Democratic Republic of the Congo": "République démocratique du Congo",
    "North Korea": "Corée du Nord",
    "South Korea": "Corée du Sud",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Côte d'Ivoire",
    "Croatia": "Croatie",
    "Cuba": "Cuba",
    "Denmark": "Danemark",
    "Djibouti": "Djibouti",
    "Dominica": "Dominique",
    "Egypt": "Égypte",
    "United Arab Emirates": "Émirats arabes unis",
    "Ecuador": "Équateur",
    "Eritrea": "Érythrée",
    "Spain": "Espagne",
    "Estonia": "Estonie",
    "Eswatini": "Eswatini",
    "United States": "États-Unis",
    "Ethiopia": "Éthiopie",
    "Fiji": "Fidji",
    "Finland": "Finlande",
    "France": "France",
    "Gabon": "Gabon",
    "Gambia": "Gambie",
    "Georgia": "Géorgie",
    "Ghana": "Ghana",
    "Greece": "Grèce",
    "Grenada": "Grenade",
    "Guatemala": "Guatemala",
    "Guinea": "Guinée",
    "Guinea-Bissau": "Guinée-Bissau",
    "Equatorial Guinea": "Guinée équatoriale",
    "Guyana": "Guyana",
    "Haiti": "Haïti",
    "Honduras": "Honduras",
    "Hungary": "Hongrie",
    "India": "Inde",
    "Indonesia": "Indonésie",
    "Iraq": "Irak",
    "Iran": "Iran",
    "Ireland": "Irlande",
    "Iceland": "Islande",
    "Israel": "Israël",
    "Italy": "Italie",
    "Jamaica": "Jamaïque",
    "Japan": "Japon",
    "Jordan": "Jordanie",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kyrgyzstan": "Kirghizistan",
    "Kiribati": "Kiribati",
    "Kuwait": "Koweït",
    "Laos": "Laos",
    "Lesotho": "Lesotho",
    "Latvia": "Lettonie",
    "Lebanon": "Liban",
    "Liberia": "Liberia",
    "Libya": "Libye",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituanie",
    "Luxembourg": "Luxembourg",
    "North Macedonia": "Macédoine du Nord",
    "Madagascar": "Madagascar",
    "Malaysia": "Malaisie",
    "Malawi": "Malawi",
    "Maldives": "Maldives",
    "Mali": "Mali",
    "Malta": "Malte",
    "Morocco": "Maroc",
    "Marshall Islands": "Îles Marshall",
    "Mauritius": "Maurice",
    "Mauritania": "Mauritanie",
    "Mexico": "Mexique",
    "Micronesia": "Micronésie",
    "Moldova": "Moldavie",
    "Monaco": "Monaco",
    "Mongolia": "Mongolie",
    "Montenegro": "Monténégro",
    "Mozambique": "Mozambique",
    "Namibia": "Namibie",
    "Nauru": "Nauru",
    "Nepal": "Népal",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Norway": "Norvège",
    "New Zealand": "Nouvelle-Zélande",
    "Oman": "Oman",
    "Uganda": "Ouganda",
    "Uzbekistan": "Ouzbékistan",
    "Pakistan": "Pakistan",
    "Palau": "Palaos",
    "Palestine": "Palestine",
    "Panama": "Panama",
    "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
    "Paraguay": "Paraguay",
    "Netherlands": "Pays-Bas",
    "Peru": "Pérou",
    "Philippines": "Philippines",
    "Poland": "Pologne",
    "Portugal": "Portugal",
    "Qatar": "Qatar",
    "Romania": "Roumanie",
    "United Kingdom": "Royaume-Uni",
    "Russia": "Russie",
    "Rwanda": "Rwanda",
    "Saint Kitts and Nevis": "Saint-Kitts-et-Nevis",
    "San Marino": "Saint-Marin",
    "Saint Vincent and the Grenadines": "Saint-Vincent-et-les-Grenadines",
    "Saint Lucia": "Sainte-Lucie",
    "El Salvador": "Salvador",
    "Samoa": "Samoa",
    "Sao Tome and Principe": "Sao Tomé-et-Principe",
    "Senegal": "Sénégal",
    "Serbia": "Serbie",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapour",
    "Slovakia": "Slovaquie",
    "Slovenia": "Slovénie",
    "Somalia": "Somalie",
    "Sudan": "Soudan",
    "South Sudan": "Soudan du Sud",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Suède",
    "Switzerland": "Suisse",
    "Suriname": "Suriname",
    "Syria": "Syrie",
    "Tajikistan": "Tadjikistan",
    "Tanzania": "Tanzanie",
    "Thailand": "Thaïlande",
    "Timor-Leste": "Timor oriental",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinité-et-Tobago",
    "Tunisia": "Tunisie",
    "Turkmenistan": "Turkménistan",
    "Turkey": "Turquie",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican": "Vatican",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Yémen",
    "Zambia": "Zambie",
    "Zimbabwe": "Zimbabwe"
};

const cfr_es = {
    "Afghanistan": "Afganistán",
    "South Africa": "Sudáfrica",
    "Albania": "Albania",
    "Algeria": "Argelia",
    "Germany": "Alemania",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua y Barbuda",
    "Saudi Arabia": "Arabia Saudita",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaiyán",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrein",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belgium": "Bélgica",
    "Belize": "Belice",
    "Benin": "Benín",
    "Bhutan": "Bután",
    "Belarus": "Bielorrusia",
    "Myanmar": "Birmania",
    "Bolivia": "Bolivia",
    "Bosnia and Herzegovina": "Bosnia y Herzegovina",
    "Botswana": "Botsuana",
    "Brazil": "Brasil",
    "Brunei": "Brunéi",
    "Bulgaria": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cabo Verde": "Cabo Verde",
    "Cambodia": "Camboya",
    "Cameroon": "Camerún",
    "Canada": "Canadá",
    "Central African Republic": "República Centroafricana",
    "Chad": "Chad",
    "Chile": "Chile",
    "China": "China",
    "Cyprus": "Chipre",
    "Colombia": "Colombia",
    "Comoros": "Comoras",
    "Republic of the Congo": "República del Congo",
    "Democratic Republic of the Congo": "República Democrática del Congo",
    "North Korea": "Corea del Norte",
    "South Korea": "Corea del Sur",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Costa de Marfil",
    "Croatia": "Croacia",
    "Cuba": "Cuba",
    "Denmark": "Dinamarca",
    "Djibouti": "Yibuti",
    "Dominica": "Dominica",
    "Egypt": "Egipto",
    "United Arab Emirates": "Emiratos Árabes Unidos",
    "Ecuador": "Ecuador",
    "Eritrea": "Eritrea",
    "Spain": "España",
    "Estonia": "Estonia",
    "Eswatini": "Esuatini",
    "United States": "Estados Unidos",
    "Ethiopia": "Etiopía",
    "Fiji": "Fiyi",
    "Finland": "Finlandia",
    "France": "Francia",
    "Gabon": "Gabón",
    "Gambia": "Gambia",
    "Georgia": "Georgia",
    "Ghana": "Ghana",
    "Greece": "Grecia",
    "Grenada": "Granada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bisáu",
    "Equatorial Guinea": "Guinea Ecuatorial",
    "Guyana": "Guyana",
    "Haiti": "Haití",
    "Honduras": "Honduras",
    "Hungary": "Hungría",
    "India": "India",
    "Indonesia": "Indonesia",
    "Iraq": "Irak",
    "Iran": "Irán",
    "Ireland": "Irlanda",
    "Iceland": "Islandia",
    "Israel": "Israel",
    "Italy": "Italia",
    "Jamaica": "Jamaica",
    "Japan": "Japón",
    "Jordan": "Jordania",
    "Kazakhstan": "Kazajistán",
    "Kenya": "Kenia",
    "Kyrgyzstan": "Kirguistán",
    "Kiribati": "Kiribati",
    "Kuwait": "Kuwait",
    "Laos": "Laos",
    "Lesotho": "Lesoto",
    "Latvia": "Letonia",
    "Lebanon": "Líbano",
    "Liberia": "Liberia",
    "Libya": "Libia",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituania",
    "Luxembourg": "Luxemburgo",
    "North Macedonia": "Macedonia del Norte",
    "Madagascar": "Madagascar",
    "Malaysia": "Malasia",
    "Malawi": "Malaui",
    "Maldives": "Maldivas",
    "Mali": "Malí",
    "Malta": "Malta",
    "Morocco": "Marruecos",
    "Marshall Islands": "Islas Marshall",
    "Mauritius": "Mauricio",
    "Mauritania": "Mauritania",
    "Mexico": "México",
    "Micronesia": "Micronesia",
    "Moldova": "Moldavia",
    "Monaco": "Mónaco",
    "Mongolia": "Mongolia",
    "Montenegro": "Montenegro",
    "Mozambique": "Mozambique",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicaragua",
    "Niger": "Níger",
    "Nigeria": "Nigeria",
    "Norway": "Noruega",
    "New Zealand": "Nueva Zelanda",
    "Oman": "Omán",
    "Uganda": "Uganda",
    "Uzbekistan": "Uzbekistán",
    "Pakistan": "Pakistán",
    "Palau": "Palaos",
    "Palestine": "Palestina",
    "Panama": "Panamá",
    "Papua New Guinea": "Papúa Nueva Guinea",
    "Paraguay": "Paraguay",
    "Netherlands": "Países Bajos",
    "Peru": "Perú",
    "Philippines": "Filipinas",
    "Poland": "Polonia",
    "Portugal": "Portugal",
    "Qatar": "Catar",
    "Romania": "Rumanía",
    "United Kingdom": "Reino Unido",
    "Russia": "Rusia",
    "Rwanda": "Ruanda",
    "Saint Kitts and Nevis": "San Cristóbal y Nieves",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
    "Saint Lucia": "Santa Lucía",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "Sao Tome and Principe": "Santo Tomé y Príncipe",
    "Senegal": "Senegal",
    "Serbia": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leona",
    "Singapore": "Singapur",
    "Slovakia": "Eslovaquia",
    "Slovenia": "Eslovenia",
    "Somalia": "Somalia",
    "Sudan": "Sudán",
    "South Sudan": "Sudán del Sur",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Suecia",
    "Switzerland": "Suiza",
    "Suriname": "Surinam",
    "Syria": "Siria",
    "Tajikistan": "Tayikistán",
    "Tanzania": "Tanzania",
    "Thailand": "Tailandia",
    "East Timor": "Timor Oriental",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad y Tobago",
    "Tunisia": "Túnez",
    "Turkmenistan": "Turkmenistán",
    "Turkey": "Turquía",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ucrania",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican City": "Vaticano",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabue"
};

const cfr_en = {
    "Afghanistan": "Afghanistan",
    "South Africa": "South Africa",
    "Albania": "Albania",
    "Algeria": "Algeria",
    "Germany": "Germany",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua and Barbuda",
    "Saudi Arabia": "Saudi Arabia",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaijan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belgium": "Belgium",
    "Belize": "Belize",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Belarus": "Belarus",
    "Myanmar": "Myanmar",
    "Bolivia": "Bolivia",
    "Bosnia and Herzegovina": "Bosnia and Herzegovina",
    "Botswana": "Botswana",
    "Brazil": "Brazil",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Cape Verde",
    "Cambodia": "Cambodia",
    "Cameroon": "Cameroon",
    "Canada": "Canada",
    "Central African Republic": "Central African Republic",
    "Chad": "Chad",
    "Chile": "Chile",
    "China": "China",
    "Cyprus": "Cyprus",
    "Colombia": "Colombia",
    "Comoros": "Comoros",
    "Republic of the Congo": "Republic of the Congo",
    "Democratic Republic of the Congo": "Democratic Republic of the Congo",
    "North Korea": "North Korea",
    "South Korea": "South Korea",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Ivory Coast",
    "Croatia": "Croatia",
    "Cuba": "Cuba",
    "Denmark": "Denmark",
    "Djibouti": "Djibouti",
    "Dominica": "Dominica",
    "Egypt": "Egypt",
    "United Arab Emirates": "United Arab Emirates",
    "Ecuador": "Ecuador",
    "Eritrea": "Eritrea",
    "Spain": "Spain",
    "Estonia": "Estonia",
    "Eswatini": "Eswatini",
    "United States": "United States",
    "Ethiopia": "Ethiopia",
    "Fiji": "Fiji",
    "Finland": "Finland",
    "France": "France",
    "Gabon": "Gabon",
    "Gambia": "Gambia",
    "Georgia": "Georgia",
    "Ghana": "Ghana",
    "Greece": "Greece",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bissau",
    "Equatorial Guinea": "Equatorial Guinea",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Hungary",
    "India": "India",
    "Indonesia": "Indonesia",
    "Iraq": "Iraq",
    "Iran": "Iran",
    "Ireland": "Ireland",
    "Iceland": "Iceland",
    "Israel": "Israel",
    "Italy": "Italy",
    "Jamaica": "Jamaica",
    "Japan": "Japan",
    "Jordan": "Jordan",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kyrgyzstan": "Kyrgyzstan",
    "Kiribati": "Kiribati",
    "Kuwait": "Kuwait",
    "Laos": "Laos",
    "Lesotho": "Lesotho",
    "Latvia": "Latvia",
    "Lebanon": "Lebanon",
    "Liberia": "Liberia",
    "Libya": "Libya",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lithuania",
    "Luxembourg": "Luxembourg",
    "North Macedonia": "North Macedonia",
    "Madagascar": "Madagascar",
    "Malaysia": "Malaysia",
    "Malawi": "Malawi",
    "Maldives": "Maldives",
    "Mali": "Mali",
    "Malta": "Malta",
    "Morocco": "Morocco",
    "Marshall Islands": "Marshall Islands",
    "Mauritius": "Mauritius",
    "Mauritania": "Mauritania",
    "Mexico": "Mexico",
    "Micronesia": "Micronesia",
    "Moldova": "Moldova",
    "Monaco": "Monaco",
    "Mongolia": "Mongolia",
    "Montenegro": "Montenegro",
    "Mozambique": "Mozambique",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Norway": "Norway",
    "New Zealand": "New Zealand",
    "Oman": "Oman",
    "Uganda": "Uganda",
    "Uzbekistan": "Uzbekistan",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Palestine": "Palestine",
    "Panama": "Panama",
    "Papua New Guinea": "Papua New Guinea",
    "Paraguay": "Paraguay",
    "Netherlands": "Netherlands",
    "Peru": "Peru",
    "Philippines": "Philippines",
    "Poland": "Poland",
    "Portugal": "Portugal",
    "Qatar": "Qatar",
    "Romania": "Romania",
    "United Kingdom": "United Kingdom",
    "Russia": "Russia",
    "Rwanda": "Rwanda",
    "Saint Kitts and Nevis": "Saint Kitts and Nevis",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
    "Saint Lucia": "Saint Lucia",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "Sao Tome and Principe": "Sao Tome and Principe",
    "Senegal": "Senegal",
    "Serbia": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapore",
    "Slovakia": "Slovakia",
    "Slovenia": "Slovenia",
    "Somalia": "Somalia",
    "Sudan": "Sudan",
    "South Sudan": "South Sudan",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Suriname": "Suriname",
    "Syria": "Syria",
    "Tajikistan": "Tajikistan",
    "Tanzania": "Tanzania",
    "Thailand": "Thailand",
    "East Timor": "East Timor",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad and Tobago",
    "Tunisia": "Tunisia",
    "Turkmenistan": "Turkmenistan",
    "Turkey": "Turkey",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican": "Vatican",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabwe"
};


const cfr_if = {
    "Afghanistan": "Afghanistan",
    "South Africa": "Sud Africa",
    "Albania": "Albania",
    "Algeria": "Algeria",
    "Germany": "Germania",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua e Barbuda",
    "Saudi Arabia": "Arabia Saudita",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaigian",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belarus": "Bielorussia",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivia",
    "Bosnia and Herzegovina": "Bosnia ed Erzegovina",
    "Botswana": "Botswana",
    "Brazil": "Brasile",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Capo Verde",
    "Cambodia": "Cambogia",
    "Cameroon": "Camerun",
    "Canada": "Canada",
    "Central African Republic": "Repubblica Centrafricana",
    "Chad": "Ciad",
    "Chile": "Cile",
    "China": "Cina",
    "Cyprus": "Cipro",
    "Colombia": "Colombia",
    "Comoros": "Comore",
    "Republic of the Congo": "Repubblica del Congo",
    "Democratic Republic of the Congo": "Repubblica Democratica del Congo",
    "North Korea": "Corea del Nord",
    "South Korea": "Corea del Sud",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Costa d'Avorio",
    "Croatia": "Croazia",
    "Cuba": "Cuba",
    "Denmark": "Danimarca",
    "Djibouti": "Gibuti",
    "Dominica": "Dominica",
    "Egypt": "Egitto",
    "United Arab Emirates": "Emirati Arabi Uniti",
    "Ecuador": "Ecuador",
    "Eritrea": "Eritrea",
    "Spain": "Spagna",
    "Estonia": "Estonia",
    "Eswatini": "Eswatini",
    "United States": "Stati Uniti",
    "Ethiopia": "Etiopia",
    "Fiji": "Figi",
    "Finland": "Finlandia",
    "France": "Francia",
    "Gabon": "Gabon",
    "Gambia": "Gambia",
    "Georgia": "Georgia",
    "Ghana": "Ghana",
    "Greece": "Grecia",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bissau",
    "Equatorial Guinea": "Guinea Equatoriale",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Ungheria",
    "India": "India",
    "Indonesia": "Indonesia",
    "Iraq": "Iraq",
    "Iran": "Iran",
    "Ireland": "Irlanda",
    "Iceland": "Islanda",
    "Israel": "Israele",
    "Italy": "Italia",
    "Jamaica": "Giamaica",
    "Japan": "Giappone",
    "Jordan": "Giordania",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kyrgyzstan": "Kirghizistan",
    "Kiribati": "Kiribati",
    "Kuwait": "Kuwait",
    "Laos": "Laos",
    "Lesotho": "Lesotho",
    "Latvia": "Lettonia",
    "Lebanon": "Libano",
    "Liberia": "Liberia",
    "Libya": "Libia",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituania",
    "Luxembourg": "Lussemburgo",
    "North Macedonia": "Macedonia del Nord",
    "Madagascar": "Madagascar",
    "Malaysia": "Malesia",
    "Malawi": "Malawi",
    "Maldives": "Maldive",
    "Mali": "Mali",
    "Malta": "Malta",
    "Morocco": "Marocco",
    "Marshall Islands": "Isole Marshall",
    "Mauritius": "Mauritius",
    "Mauritania": "Mauritania",
    "Mexico": "Messico",
    "Micronesia": "Micronesia",
    "Moldova": "Moldavia",
    "Monaco": "Monaco",
    "Mongolia": "Mongolia",
    "Montenegro": "Montenegro",
    "Mozambique": "Mozambico",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Norway": "Norvegia",
    "New Zealand": "Nuova Zelanda",
    "Oman": "Oman",
    "Uganda": "Uganda",
    "Uzbekistan": "Uzbekistan",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Palestine": "Palestina",
    "Panama": "Panama",
    "Papua New Guinea": "Papua Nuova Guinea",
    "Paraguay": "Paraguay",
    "Netherlands": "Paesi Bassi",
    "Peru": "Perù",
    "Philippines": "Filippine",
    "Poland": "Polonia",
    "Portugal": "Portogallo",
    "Qatar": "Qatar",
    "Romania": "Romania",
    "United Kingdom": "Regno Unito",
    "Russia": "Russia",
    "Rwanda": "Ruanda",
    "Saint Kitts and Nevis": "Saint Kitts e Nevis",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "Saint Vincent e Grenadine",
    "Saint Lucia": "Santa Lucia",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "São Tomé and Príncipe": "São Tomé e Príncipe",
    "Senegal": "Senegal",
    "Serbia": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapore",
    "Slovakia": "Slovacchia",
    "Slovenia": "Slovenia",
    "Somalia": "Somalia",
    "Sudan": "Sudan",
    "South Sudan": "Sudan del Sud",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Svezia",
    "Switzerland": "Svizzera",
    "Suriname": "Suriname",
    "Syria": "Siria",
    "Tajikistan": "Tagikistan",
    "Tanzania": "Tanzania",
    "Thailand": "Thailandia",
    "East Timor": "Timor Est",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad e Tobago",
    "Tunisia": "Tunisia",
    "Turkmenistan": "Turkmenistan",
    "Turkey": "Turchia",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ucraina",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican": "Vaticano",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabwe"
}

const cfr_ja = {
    "South Africa": "南アフリカ",
    "Albania": "アルバニア",
    "Algeria": "アルジェリア",
    "Germany": "ドイツ",
    "Andorra": "アンドラ",
    "Angola": "アンゴラ",
    "Antigua and Barbuda": "アンティグア・バーブーダ",
    "Saudi Arabia": "サウジアラビア",
    "Argentina": "アルゼンチン",
    "Armenia": "アルメニア",
    "Australia": "オーストラリア",
    "Austria": "オーストリア",
    "Azerbaijan": "アゼルバイジャン",
    "Bahamas": "バハマ",
    "Bahrain": "バーレーン",
    "Bangladesh": "バングラデシュ",
    "Barbados": "バルバドス",
    "Belarus": "ベラルーシ",
    "Benin": "ベニン",
    "Bhutan": "ブータン",
    "Bolivia": "ボリビア",
    "Bosnia and Herzegovina": "ボスニア・ヘルツェゴビナ",
    "Botswana": "ボツワナ",
    "Brazil": "ブラジル",
    "Brunei": "ブルネイ",
    "Bulgaria": "ブルガリア",
    "Burkina Faso": "ブルキナファソ",
    "Burundi": "ブルンジ",
    "Cape Verde": "カーボベルデ",
    "Cambodia": "カンボジア",
    "Cameroon": "カメルーン",
    "Canada": "カナダ",
    "Central African Republic": "中央アフリカ共和国",
    "Chad": "チャド",
    "Chile": "チリ",
    "China": "中国",
    "Cyprus": "キプロス",
    "Colombia": "コロンビア",
    "Comoros": "コモロ",
    "Republic of the Congo": "コンゴ共和国",
    "Democratic Republic of the Congo": "コンゴ民主共和国",
    "North Korea": "北朝鮮",
    "South Korea": "韓国",
    "Costa Rica": "コスタリカ",
    "Ivory Coast": "コートジボワール",
    "Croatia": "クロアチア",
    "Cuba": "キューバ",
    "Denmark": "デンマーク",
    "Djibouti": "ジブチ",
    "Dominica": "ドミニカ",
    "Egypt": "エジプト",
    "United Arab Emirates": "アラブ首長国連邦",
    "Ecuador": "エクアドル",
    "Eritrea": "エリトリア",
    "Spain": "スペイン",
    "Estonia": "エストニア",
    "Eswatini": "エスワティニ",
    "United States": "アメリカ合衆国",
    "Ethiopia": "エチオピア",
    "Fiji": "フィジー",
    "Finland": "フィンランド",
    "France": "フランス",
    "Gabon": "ガボン",
    "Gambia": "ガンビア",
    "Georgia": "ジョージア",
    "Ghana": "ガーナ",
    "Greece": "ギリシャ",
    "Grenada": "グレナダ",
    "Guatemala": "グアテマラ",
    "Guinea": "ギニア",
    "Guinea-Bissau": "ギニアビサウ",
    "Equatorial Guinea": "赤道ギニア",
    "Guyana": "ガイアナ",
    "Haiti": "ハイチ",
    "Honduras": "ホンジュラス",
    "Hungary": "ハンガリー",
    "India": "インド",
    "Indonesia": "インドネシア",
    "Iraq": "イラク",
    "Iran": "イラン",
    "Ireland": "アイルランド",
    "Iceland": "アイスランド",
    "Israel": "イスラエル",
    "Italy": "イタリア",
    "Jamaica": "ジャマイカ",
    "Japan": "日本",
    "Jordan": "ヨルダン",
    "Kazakhstan": "カザフスタン",
    "Kenya": "ケニア",
    "Kyrgyzstan": "キルギス",
    "Kiribati": "キリバス",
    "Kuwait": "クウェート",
    "Laos": "ラオス",
    "Lesotho": "レソト",
    "Latvia": "ラトビア",
    "Lebanon": "レバノン",
    "Liberia": "リベリア",
    "Libya": "リビア",
    "Liechtenstein": "リヒテンシュタイン",
    "Lithuania": "リトアニア",
    "Luxembourg": "ルクセンブルク",
    "North Macedonia": "北マケドニア",
    "Madagascar": "マダガスカル",
    "Malaysia": "マレーシア",
    "Malawi": "マラウイ",
    "Maldives": "モルディブ",
    "Mali": "マリ",
    "Malta": "マルタ",
    "Morocco": "モロッコ",
    "Marshall Islands": "マーシャル諸島",
    "Mauritius": "モーリシャス",
    "Mauritania": "モーリタニア",
    "Mexico": "メキシコ",
    "Micronesia": "ミクロネシア",
    "Moldova": "モルドバ",
    "Monaco": "モナコ",
    "Mongolia": "モンゴル",
    "Montenegro": "モンテネグロ",
    "Mozambique": "モザンビーク",
    "Namibia": "ナミビア",
    "Nauru": "ナウル",
    "Nepal": "ネパール",
    "Nicaragua": "ニカラグア",
    "Niger": "ニジェール",
    "Nigeria": "ナイジェリア",
    "Norway": "ノルウェー",
    "New Zealand": "ニュージーランド",
    "Oman": "オマーン",
    "Uganda": "ウガンダ",
    "Uzbekistan": "ウズベキスタン",
    "Pakistan": "パキスタン",
    "Palau": "パラオ",
    "Palestine": "パレスチナ",
    "Panama": "パナマ",
    "Papua New Guinea": "パプアニューギニア",
    "Paraguay": "パラグアイ",
    "Netherlands": "オランダ",
    "Peru": "ペルー",
    "Philippines": "フィリピン",
    "Poland": "ポーランド",
    "Portugal": "ポルトガル",
    "Qatar": "カタール",
    "Romania": "ルーマニア",
    "United Kingdom": "イギリス",
    "Russia": "ロシア",
    "Rwanda": "ルワンダ",
    "Saint Kitts and Nevis": "セントキッツ・ネービス",
    "San Marino": "サンマリノ",
    "Saint Vincent and the Grenadines": "セントビンセント・グレナディーン諸島",
    "Saint Lucia": "セントルシア",
    "El Salvador": "エルサルバドル",
    "Samoa": "サモア",
    "Sao Tome and Principe": "サントメ・プリンシペ",
    "Senegal": "セネガル",
    "Serbia": "セルビア",
    "Seychelles": "セーシェル",
    "Sierra Leone": "シエラレオネ",
    "Singapore": "シンガポール",
    "Slovakia": "スロバキア",
    "Slovenia": "スロベニア",
    "Somalia": "ソマリア",
    "Sudan": "スーダン",
    "South Sudan": "南スーダン",
    "Sri Lanka": "スリランカ",
    "Sweden": "スウェーデン",
    "Switzerland": "スイス",
    "Suriname": "スリナム",
    "Syria": "シリア",
    "Tajikistan": "タジキスタン",
    "Tanzania": "タンザニア",
    "Thailand": "タイ",
    "East Timor": "東ティモール",
    "Togo": "トーゴ",
    "Tonga": "トンガ",
    "Trinidad and Tobago": "トリニダード・トバゴ",
    "Tunisia": "チュニジア",
    "Turkmenistan": "トルクメニスタン",
    "Turkey": "トルコ",
    "Tuvalu": "ツバル",
    "Ukraine": "ウクライナ",
    "Uruguay": "ウルグアイ",
    "Vanuatu": "バヌアツ",
    "Vatican": "バチカン",
    "Venezuela": "ベネズエラ",
    "Vietnam": "ベトナム",
    "Yemen": "イエメン",
    "Zambia": "ザンビア",
    "Zimbabwe": "ジンバブエ"
}

const cfr_pt = {
    "Afghanistan": "Afeganistão",
    "South Africa": "África do Sul",
    "Albania": "Albânia",
    "Algeria": "Argélia",
    "Germany": "Alemanha",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antígua e Barbuda",
    "Saudi Arabia": "Arábia Saudita",
    "Argentina": "Argentina",
    "Armenia": "Armênia",
    "Australia": "Austrália",
    "Austria": "Áustria",
    "Azerbaijan": "Azerbaijão",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrein",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belarus": "Bielorrússia",
    "Benin": "Benim",
    "Bhutan": "Butão",
    "Bolivia": "Bolívia",
    "Bosnia and Herzegovina": "Bósnia e Herzegovina",
    "Botswana": "Botsuana",
    "Brazil": "Brasil",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgária",
    "Burkina Faso": "Burquina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Cabo Verde",
    "Cambodia": "Camboja",
    "Cameroon": "Camarões",
    "Canada": "Canadá",
    "Central African Republic": "República Centro-Africana",
    "Chad": "Chade",
    "Chile": "Chile",
    "China": "China",
    "Cyprus": "Chipre",
    "Colombia": "Colômbia",
    "Comoros": "Comores",
    "Republic of the Congo": "República do Congo",
    "Democratic Republic of the Congo": "República Democrática do Congo",
    "North Korea": "Coreia do Norte",
    "South Korea": "Coreia do Sul",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Costa do Marfim",
    "Croatia": "Croácia",
    "Cuba": "Cuba",
    "Denmark": "Dinamarca",
    "Djibouti": "Djibuti",
    "Dominica": "Dominica",
    "Egypt": "Egito",
    "United Arab Emirates": "Emirados Árabes Unidos",
    "Ecuador": "Equador",
    "Eritrea": "Eritreia",
    "Spain": "Espanha",
    "Estonia": "Estónia",
    "Eswatini": "Eswatini",
    "United States": "Estados Unidos",
    "Ethiopia": "Etiópia",
    "Fiji": "Fiji",
    "Finland": "Finlândia",
    "France": "França",
    "Gabon": "Gabão",
    "Gambia": "Gâmbia",
    "Georgia": "Geórgia",
    "Ghana": "Gana",
    "Greece": "Grécia",
    "Grenada": "Granada",
    "Guatemala": "Guatemala",
    "Guinea": "Guiné",
    "Guinea-Bissau": "Guiné-Bissau",
    "Equatorial Guinea": "Guiné Equatorial",
    "Guyana": "Guiana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Hungria",
    "India": "Índia",
    "Indonesia": "Indonésia",
    "Iraq": "Iraque",
    "Iran": "Irã",
    "Ireland": "Irlanda",
    "Iceland": "Islândia",
    "Israel": "Israel",
    "Italy": "Itália",
    "Jamaica": "Jamaica",
    "Japan": "Japão",
    "Jordan": "Jordânia",
    "Kazakhstan": "Cazaquistão",
    "Kenya": "Quênia",
    "Kyrgyzstan": "Quirguistão",
    "Kiribati": "Kiribati",
    "Kuwait": "Kuwait",
    "Laos": "Laos",
    "Lesotho": "Lesoto",
    "Latvia": "Letônia",
    "Lebanon": "Líbano",
    "Liberia": "Libéria",
    "Libya": "Líbia",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituânia",
    "Luxembourg": "Luxemburgo",
    "North Macedonia": "Macedônia do Norte",
    "Madagascar": "Madagáscar",
    "Malaysia": "Malásia",
    "Malawi": "Malawi",
    "Maldives": "Maldivas",
    "Mali": "Mali",
    "Malta": "Malta",
    "Morocco": "Marrocos",
    "Marshall Islands": "Ilhas Marshall",
    "Mauritius": "Maurício",
    "Mauritania": "Mauritânia",
    "Mexico": "México",
    "Micronesia": "Micronésia",
    "Moldova": "Moldávia",
    "Monaco": "Mônaco",
    "Mongolia": "Mongólia",
    "Montenegro": "Montenegro",
    "Mozambique": "Moçambique",
    "Namibia": "Namíbia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicarágua",
    "Niger": "Níger",
    "Nigeria": "Nigéria",
    "Norway": "Noruega",
    "New Zealand": "Nova Zelândia",
    "Oman": "Omã",
    "Uganda": "Uganda",
    "Uzbekistan": "Uzbequistão",
    "Pakistan": "Paquistão",
    "Palau": "Palau",
    "Palestine": "Palestina",
    "Panama": "Panamá",
    "Papua New Guinea": "Papua Nova Guiné",
    "Paraguay": "Paraguai",
    "Netherlands": "Países Baixos",
    "Peru": "Peru",
    "Philippines": "Filipinas",
    "Poland": "Polônia",
    "Portugal": "Portugal",
    "Qatar": "Catar",
    "Romania": "Romênia",
    "United Kingdom": "Reino Unido",
    "Russia": "Rússia",
    "Rwanda": "Ruanda",
    "Saint Kitts and Nevis": "São Cristóvão e Nevis",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
    "Saint Lucia": "Santa Lúcia",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "Sao Tome and Principe": "São Tomé e Príncipe",
    "Senegal": "Senegal",
    "Serbia": "Sérvia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Serra Leoa",
    "Singapore": "Cingapura",
    "Slovakia": "Eslováquia",
    "Slovenia": "Eslovênia",
    "Somalia": "Somália",
    "Sudan": "Sudão",
    "South Sudan": "Sudão do Sul",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Suécia",
    "Switzerland": "Suíça",
    "Suriname": "Suriname",
    "Syria": "Síria",
    "Tajikistan": "Tajiquistão",
    "Tanzania": "Tanzânia",
    "Thailand": "Tailândia",
    "East Timor": "Timor Leste",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad e Tobago",
    "Tunisia": "Tunísia",
    "Turkmenistan": "Turcomenistão",
    "Turkey": "Turquia",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ucrânia",
    "Uruguay": "Uruguai",
    "Vanuatu": "Vanuatu",
    "Vatican": "Vaticano",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnã",
    "Yemen": "Iémen",
    "Zambia": "Zâmbia",
    "Zimbabwe": "Zimbábue"
}

const cfr_nl = {
    "South Africa": "Zuid-Afrika",
    "Albania": "Albanië",
    "Algeria": "Algerije",
    "Germany": "Duitsland",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua en Barbuda",
    "Saudi Arabia": "Saoedi-Arabië",
    "Argentina": "Argentinië",
    "Armenia": "Armenië",
    "Australia": "Australië",
    "Austria": "Oostenrijk",
    "Azerbaijan": "Azerbeidzjan",
    "Bahamas": "Bahama's",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belarus": "Wit-Rusland",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivië",
    "Bosnia and Herzegovina": "Bosnië en Herzegovina",
    "Botswana": "Botswana",
    "Brazil": "Brazilië",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgarije",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Kaapverdië",
    "Cambodia": "Cambodja",
    "Cameroon": "Kameroen",
    "Canada": "Canada",
    "Central African Republic": "Centraal-Afrikaanse Republiek",
    "Chad": "Tsjaad",
    "Chile": "Chili",
    "China": "China",
    "Cyprus": "Cyprus",
    "Colombia": "Colombia",
    "Comoros": "Comoren",
    "Republic of the Congo": "Congo",
    "Democratic Republic of the Congo": "Democratische Republiek Congo",
    "North Korea": "Noord-Korea",
    "South Korea": "Zuid-Korea",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Ivoorkust",
    "Croatia": "Kroatië",
    "Cuba": "Cuba",
    "Denmark": "Denemarken",
    "Djibouti": "Djibouti",
    "Dominica": "Dominica",
    "Egypt": "Egypte",
    "United Arab Emirates": "Verenigde Arabische Emiraten",
    "Ecuador": "Ecuador",
    "Eritrea": "Eritrea",
    "Spain": "Spanje",
    "Estonia": "Estland",
    "Eswatini": "Eswatini",
    "United States": "Verenigde Staten",
    "Ethiopia": "Ethiopië",
    "Fiji": "Fiji",
    "Finland": "Finland",
    "France": "Frankrijk",
    "Gabon": "Gabon",
    "Gambia": "Gambia",
    "Georgia": "Georgië",
    "Ghana": "Ghana",
    "Greece": "Griekenland",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinee",
    "Guinea-Bissau": "Guinee-Bissau",
    "Equatorial Guinea": "Equatoriaal-Guinea",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Hongarije",
    "India": "India",
    "Indonesia": "Indonesië",
    "Iraq": "Irak",
    "Iran": "Iran",
    "Ireland": "Ierland",
    "Iceland": "IJsland",
    "Israel": "Israël",
    "Italy": "Italië",
    "Jamaica": "Jamaica",
    "Japan": "Japan",
    "Jordan": "Jordanië",
    "Kazakhstan": "Kazachstan",
    "Kenya": "Kenia",
    "Kyrgyzstan": "Kirgizië",
    "Kiribati": "Kiribati",
    "Kuwait": "Koeweit",
    "Laos": "Laos",
    "Lesotho": "Lesotho",
    "Latvia": "Letland",
    "Lebanon": "Libanon",
    "Liberia": "Liberia",
    "Libya": "Libië",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Litouwen",
    "Luxembourg": "Luxemburg",
    "North Macedonia": "Noord-Macedonië",
    "Madagascar": "Madagaskar",
    "Malaysia": "Maleisië",
    "Malawi": "Malawi",
    "Maldives": "Maldiven",
    "Mali": "Mali",
    "Malta": "Malta",
    "Morocco": "Marokko",
    "Marshall Islands": "Marshall-eilanden",
    "Mauritius": "Mauritius",
    "Mauritania": "Mauritanië",
    "Mexico": "Mexico",
    "Micronesia": "Micronesië",
    "Moldova": "Moldavië",
    "Monaco": "Monaco",
    "Mongolia": "Mongolië",
    "Montenegro": "Montenegro",
    "Mozambique": "Mozambique",
    "Namibia": "Namibië",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Norway": "Noorwegen",
    "New Zealand": "Nieuw-Zeeland",
    "Oman": "Oman",
    "Uganda": "Oeganda",
    "Uzbekistan": "Oezbekistan",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Palestine": "Palestina",
    "Panama": "Panama",
    "Papua New Guinea": "Papoea-Nieuw-Guinea",
    "Paraguay": "Paraguay",
    "Netherlands": "Nederland",
    "Peru": "Peru",
    "Philippines": "Filipijnen",
    "Poland": "Polen",
    "Portugal": "Portugal",
    "Qatar": "Qatar",
    "Romania": "Roemenië",
    "United Kingdom": "Verenigd Koninkrijk",
    "Russia": "Rusland",
    "Rwanda": "Rwanda",
    "Saint Kitts and Nevis": "Saint Kitts en Nevis",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "Saint Vincent en de Grenadines",
    "Saint Lucia": "Saint Lucia",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "São Tomé and Príncipe": "Sao Tomé en Principe",
    "Senegal": "Senegal",
    "Serbia": "Servië",
    "Seychelles": "Seychellen",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapore",
    "Slovakia": "Slowakije",
    "Slovenia": "Slovenië",
    "Somalia": "Somalië",
    "Sudan": "Soedan",
    "South Sudan": "Zuid-Soedan",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Zweden",
    "Switzerland": "Zwitserland",
    "Suriname": "Suriname",
    "Syria": "Syrië",
    "Tajikistan": "Tadzjikistan",
    "Tanzania": "Tanzania",
    "Thailand": "Thailand",
    "East Timor": "Oost-Timor",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad en Tobago",
    "Tunisia": "Tunesië",
    "Turkmenistan": "Turkmenistan",
    "Turkey": "Turkije",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Oekraïne",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican City": "Vaticaanstad",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Jemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabwe"
}


const cfr_de = {
    "South Africa": "Südafrika",
    "Albania": "Albanien",
    "Algeria": "Algerien",
    "Germany": "Deutschland",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua und Barbuda",
    "Saudi Arabia": "Saudi-Arabien",
    "Argentina": "Argentinien",
    "Armenia": "Armenien",
    "Australia": "Australien",
    "Austria": "Österreich",
    "Azerbaijan": "Aserbaidschan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesch",
    "Barbados": "Barbados",
    "Belarus": "Weißrussland",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivien",
    "Bosnia and Herzegovina": "Bosnien und Herzegowina",
    "Botswana": "Botswana",
    "Brazil": "Brasilien",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgarien",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cape Verde": "Kap Verde",
    "Cambodia": "Kambodscha",
    "Cameroon": "Kamerun",
    "Canada": "Kanada",
    "Central African Republic": "Zentralafrikanische Republik",
    "Chad": "Tschad",
    "Chile": "Chile",
    "China": "China",
    "Cyprus": "Zypern",
    "Colombia": "Kolumbien",
    "Comoros": "Komoren",
    "Congo": "Kongo",
    "Democratic Republic of the Congo": "Demokratische Republik Kongo",
    "North Korea": "Nordkorea",
    "South Korea": "Südkorea",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Elfenbeinküste",
    "Croatia": "Kroatien",
    "Cuba": "Kuba",
    "Denmark": "Dänemark",
    "Djibouti": "Dschibuti",
    "Dominica": "Dominica",
    "Egypt": "Ägypten",
    "United Arab Emirates": "Vereinigte Arabische Emirate",
    "Ecuador": "Ecuador",
    "Eritrea": "Eritrea",
    "Spain": "Spanien",
    "Estonia": "Estland",
    "Eswatini": "Eswatini",
    "United States": "Vereinigte Staaten",
    "Ethiopia": "Äthiopien",
    "Fiji": "Fidschi",
    "Finland": "Finnland",
    "France": "Frankreich",
    "Gabon": "Gabun",
    "Gambia": "Gambia",
    "Georgia": "Georgien",
    "Ghana": "Ghana",
    "Greece": "Griechenland",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bissau",
    "Equatorial Guinea": "Äquatorialguinea",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Ungarn",
    "India": "Indien",
    "Indonesia": "Indonesien",
    "Iraq": "Irak",
    "Iran": "Iran",
    "Ireland": "Irland",
    "Iceland": "Island",
    "Israel": "Israel",
    "Italy": "Italien",
    "Jamaica": "Jamaika",
    "Japan": "Japan",
    "Jordan": "Jordanien",
    "Kazakhstan": "Kasachstan",
    "Kenya": "Kenia",
    "Kyrgyzstan": "Kirgisistan",
    "Kiribati": "Kiribati",
    "Kuwait": "Kuwait",
    "Laos": "Laos",
    "Lesotho": "Lesotho",
    "Latvia": "Lettland",
    "Lebanon": "Libanon",
    "Liberia": "Liberia",
    "Libya": "Libyen",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Litauen",
    "Luxembourg": "Luxemburg",
    "North Macedonia": "Nordmazedonien",
    "Madagascar": "Madagaskar",
    "Malaysia": "Malaysia",
    "Malawi": "Malawi",
    "Maldives": "Malediven",
    "Mali": "Mali",
    "Malta": "Malta",
    "Morocco": "Marokko",
    "Marshall Islands": "Marshallinseln",
    "Mauritius": "Mauritius",
    "Mauritania": "Mauritanien",
    "Mexico": "Mexiko",
    "Micronesia": "Mikronesien",
    "Moldova": "Moldawien",
    "Monaco": "Monaco",
    "Mongolia": "Mongolei",
    "Montenegro": "Montenegro",
    "Mozambique": "Mosambik",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Norway": "Norwegen",
    "New Zealand": "Neuseeland",
    "Oman": "Oman",
    "Uganda": "Uganda",
    "Uzbekistan": "Usbekistan",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Palestine": "Palästina",
    "Panama": "Panama",
    "Papua New Guinea": "Papua-Neuguinea",
    "Paraguay": "Paraguay",
    "Netherlands": "Niederlande",
    "Peru": "Peru",
    "Philippines": "Philippinen",
    "Poland": "Polen",
    "Portugal": "Portugal",
    "Qatar": "Katar",
    "Romania": "Rumänien",
    "United Kingdom": "Vereinigtes Königreich",
    "Russia": "Russland",
    "Rwanda": "Ruanda",
    "Saint Kitts and Nevis": "Saint Kitts und Nevis",
    "San Marino": "San Marino",
    "Saint Vincent and the Grenadines": "Saint Vincent und die Grenadinen",
    "Saint Lucia": "Saint Lucia",
    "El Salvador": "El Salvador",
    "Samoa": "Samoa",
    "Sao Tome and Principe": "São Tomé und Príncipe",
    "Senegal": "Senegal",
    "Serbia": "Serbien",
    "Seychelles": "Seychellen",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapur",
    "Slovakia": "Slowakei",
    "Slovenia": "Slowenien",
    "Somalia": "Somalia",
    "Sudan": "Sudan",
    "South Sudan": "Südsudan",
    "Sri Lanka": "Sri Lanka",
    "Sweden": "Schweden",
    "Switzerland": "Schweiz",
    "Suriname": "Suriname",
    "Syria": "Syrien",
    "Tajikistan": "Tadschikistan",
    "Tanzania": "Tansania",
    "Thailand": "Thailand",
    "East Timor": "Osttimor",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad und Tobago",
    "Tunisia": "Tunesien",
    "Turkmenistan": "Turkmenistan",
    "Turkey": "Türkei",
    "Tuvalu": "Tuvalu",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Vanuatu": "Vanuatu",
    "Vatican City": "Vatikanstadt",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Jemen",
    "Zambia": "Sambia",
    "Zimbabwe": "Simbabwe"
};


// Exporter plusieurs objets
module.exports = { cfr, cfr_es, cfr_en, cfr_if, cfr_pt, cfr_ja, cfr_nl, cfr_de };